module.exports = __webpack_public_path__ + "media/images/favicon/primary/android-icon-192x192-39a992913b87fc1ff85b4196fd252858.png";